import React from "react";
//#region types
import { CategorySelectorProps } from "models/propTypes/wintSalaryPropTypes";
//#endregion
//#region components
import { MenuItem, Grid, Input, SelectChangeEvent } from "@mui/material";
import ControlledSelect from "../../common/forms/baseFields/select";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const CategorySelector: React.FC<CategorySelectorProps> = (props) => {
  const { onCategoryChange, availableCategories, selectedCategory, title } = props;
  const onSelectCategoryChange = (event: SelectChangeEvent<number | string>) => {
    const incoming = Number(event.target.value);
    const category = availableCategories.find((c) => c.id === incoming) ?? availableCategories[0];
    if (category) onCategoryChange(category);
  };

  return (
    <Grid container direction="row" columnGap={1}>
      <Grid item>{title}: </Grid>
      <Grid item className={cssExports.ControlledSelector}>
        <ControlledSelect
          value={
            availableCategories.some((c) => c.id === selectedCategory)
              ? selectedCategory
              : (availableCategories[0]?.id ?? "")
          }
          input={<Input disableUnderline />}
          classes={{ select: cssExports.itemSelector, iconFilled: cssExports.itemSelectorIcon }}
          onChange={onSelectCategoryChange}
          variant={"filled"}
        >
          {availableCategories.map((category) => (
            <MenuItem className={cssExports.popoverItem} key={category.id} value={category.id}>
              {category.value}
            </MenuItem>
          ))}
        </ControlledSelect>
      </Grid>
    </Grid>
  );
};

export default CategorySelector;
